<template src="./gestioneUtente.html"></template>

<script>
import DialogCliente from "@/components/dialog/DettaglioCliente.vue";
import { get_listaClienti, delete_cliente, get_certificazioni, get_clientiExcel, get_clientiExcelPEFC } from "@/api/api.dati.js";
import { excel_approvazioni_loghi } from "@/api/api.clienti.js";

var XLSX = require("xlsx");

import mixinUtente from "@/utils/dati/mixinUtente";

export default {
    components: { DialogCliente },

    mixins: [mixinUtente],

    data: () => ({
        headerProps: {
            sortByText: "Ordina per",
        },
        page: 1,
        pageCount: 0,
        search: "",
        loadingTabella: false,
        clienti: [],
        dialogCliente: false,
        dialogEsporta: false,
        dialogEsportaLoghi: false,
        annoEsportaLoghi: new Date().getFullYear(),

        expanded: [],
        gruppo: ["Tutti", "G", "S"],
        gruppoSel: -1,
        certificazione: [],
        certificazioneSel: -1,
        editedItem: {},
        isEdited: false,

        headersDati: [],

        selectedRow: null,

        dialogDataCoc: false,
        dialogDataFPC: false,
        dataCocIT: new Date().toISOString().substr(0, 10),
        dataCoc: new Date().toISOString().substr(0, 10),
        dataFPCIT: new Date().toISOString().substr(0, 10),
        dataFPC: new Date().toISOString().substr(0, 10),
    }),

    methods: {
        async CaricaDati() {
            this.loadingTabella = true;

            this.clienti = [];
            let par = {
                Cliente: true,
                Gruppo: this.gruppoSel,
                Certificazione: "",
                DataCoc: "",
                DataFPC: "",
                MostraDisabilitati: true, // qui i clienti disabilitati devono continuare a comparire, per poterli riattivare
            }
            //controllo per filtro date Audit
            if (this.dataCocIT != "" && this.dataCocIT != null) par.DataCoc = this.dataCoc;
            else par.DataCoc = "";
            if (this.dataFPCIT != "" && this.dataFPCIT != null) par.DataFPC = this.dataFPC;
            else par.DataFPC = "";
            //controllo per filtro Certificazione
            par.Certificazione = this.certificazioneSel.certificazione;

            let res = await get_listaClienti(par);
            this.clienti = res.data;

            this.loadingTabella = false;
        },

        async refresh() {
            //reset filtri
            this.resetFiltri();

            await this.CaricaDati();
        },

        resetFiltri() {
            this.gruppoSel = this.gruppo[0];
            this.certificazioneSel = this.certificazione[0];

            this.dialogDataCoc = false;
            this.dialogDataFPC = false;
            //this.dataCoc = new Date().toISOString().substr(0, 10);
            //this.dataFPC = new Date().toISOString().substr(0, 10);
            this.dataCocIT = "";
            this.dataFPCIT = "";
        },

        selectRow(i) {
            this.selectedRow = i;
        },

        async deleteItem(item) {
            let numero = item.userId - 1;
            let confirm = await this.$confirm.open("Elimina cliente n°" + numero, "Vuoi eliminare il cliente: <b>" + item.username + "</b>?");
            if (!confirm) return;

            this.loadingTabella = true;
            item.certificazione = "";
            let res = await delete_cliente(item);
            if (res.data == "OK") {
                this.CaricaDati();
                if (item.id != 0) this.CaricaDati();
                this.$toast.info("Cliente eliminato con successo!");
            } else this.$toast.alert("Impossibile eliminare il cliente!");

            this.loadingTabella = false;
        },

        editItem(item) {
            item.expanded = false;
            this.editedItem = item;
            this.operazione = "Modifica elemento";
            this.isEdited = true;
            this.dialogCliente = true;
        },

        aggiungi() {
            this.isEdited = false;
            this.dialogCliente = true;
        },

        chiudiCliente(value) {
            this.editedItem = null;
            this.dialogCliente = false;
            if (!value) this.refresh();
        },

        async GetCertificazioni() {
            this.loadingTabella = true;
            this.certificazione = [];

            let res = await get_certificazioni();
            this.certificazione = [{ id: 0, certificazione: "Tutti" }, ...res.data];

            this.loadingTabella = false;
        },

        apriDialogEsporta() {
            this.dialogEsporta = true;
        },

        scaricaWorkbook(sheetData, nomeFile, colonne) {
            let workbook = XLSX.utils.book_new();
            let ws = XLSX.utils.aoa_to_sheet(sheetData);
            if (colonne) ws["!cols"] = colonne;
            XLSX.utils.book_append_sheet(workbook, ws, nomeFile);
            let wopts = { bookType: "xlsx", bookSST: false, type: "array" };
            XLSX.writeFile(workbook, nomeFile + ".xlsx", wopts);
        },

        async esportaGruppoFSC() {
            this.dialogEsporta = false;
            this.$wait.open();
            let res = await get_clientiExcel();
            this.scaricaWorkbook(res.data, "ReportClientiGruppoFSC", this.getDimensioneColonne());
            this.$wait.close();
        },

        async esportaGruppoPEFC() {
            this.dialogEsporta = false;
            this.$wait.open();
            let res = await get_clientiExcelPEFC();
            this.scaricaWorkbook(res.data, "ReportClientiGruppoPEFC", this.getDimensioneColonne());
            this.$wait.close();
        },

        formattaDataVisibile(data) {
            if (!data || data === "01/01/1900" || data === "") return "";
            return this.$i2kFunctions.formatISODate(data);
        },

        esportaTabellaVisualizzata() {
            this.dialogEsporta = false;
            this.$wait.open();

            const headers = [
                "Codice utente", "Ragione Sociale", "Gruppo", "Certificazione",
                "Audit FSC", "Audit FSC Gruppo", "Audit FPC", "Audit ISO", "Audit PEFC", "Audit PEFC Gruppo",
                "Stato",
            ];

            const righe = this.clientiFiltrati.map((c) => [
                c.companyCode || "",
                c.ragioneSociale || "",
                c.gruppo || "",
                c.certificazione || "",
                this.formattaDataVisibile(c.dataAuditFSCS),
                this.formattaDataVisibile(c.dataAuditFSCG),
                this.formattaDataVisibile(c.dataAuditFPC),
                this.formattaDataVisibile(c.dataAuditISO),
                this.formattaDataVisibile(c.dataAuditPEFC),
                this.formattaDataVisibile(c.dataAuditPEFCG),
                c.enabled ? "Abilitato" : "Disabilitato",
            ]);

            this.scaricaWorkbook([headers, ...righe], "TabellaClienti", null);
            this.$wait.close();
        },

        apriDialogEsportaLoghi() {
            this.dialogEsporta = false;
            this.dialogEsportaLoghi = true;
        },

        async esportaApprovazioniLoghi() {
            this.$wait.open();
            let res = await excel_approvazioni_loghi(this.annoEsportaLoghi);
            this.scaricaWorkbook(res.data, "ApprovazioneLoghi" + this.annoEsportaLoghi, null);
            this.dialogEsportaLoghi = false;
            this.$wait.close();
        },
    },

    async mounted() {
        //data Audit Coc
        let data = new Date(this.dataCocIT);
        data.setDate(data.getDate()); //formato system
        data = this.$i2kFunctions.formatDate_IT(data); //dd/MM//YYYY;
        this.dataCocIT = "";
        //data audit FPC
        let data1 = new Date(this.dataFPCIT);
        data1.setDate(data1.getDate()); //formato system
        data1 = this.$i2kFunctions.formatDate_IT(data1); //dd/MM//YYYY;
        this.dataFPCIT = "";

        this.gruppoSel = this.gruppo[0];
        await this.GetCertificazioni();
        this.certificazioneSel = this.certificazione[0];
        await this.CaricaDati();
    },

    watch: {
        dataCoc() {
            let data = new Date(this.dataCoc);
            data.setDate(data.getDate()); //formato system
            data = this.$i2kFunctions.formatDate_IT(data); //dd/MM//YYYY;
            this.dataCocIT = data;
        },
        dataFPC() {
            let data = new Date(this.dataFPC);
            data.setDate(data.getDate()); //formato system
            data = this.$i2kFunctions.formatDate_IT(data); //dd/MM//YYYY;
            this.dataFPCIT = data;
        },
        async dataCocIT(newVal) {
            if (newVal) {
                this.dataFPCIT = "";
                await this.CaricaDati();
            }
        },
        async dataFPCIT(newVal) {
            if (newVal) {
                this.dataCocIT = "";
                await this.CaricaDati();
            }
        },
    },

    created() {
        if (!["admin", "auditor"].includes(this.role))
            this.$router.push({ path: "/" });
        this.headersDati = this.getHeadersTabella();
    },

    computed: {
        GetLoading() {
            return this.$store.getters["app/getLoading"];
        },
        role() {
            return this.$store.getters['user/getRole'];
        },

        // Filtro testuale applicato manualmente (sostituisce il prop nativo :search di Vuetify, che con
        // questa tabella - header custom con value:"" su Certificazione/Audit - filtrava solo su
        // companyCode/ragioneSociale/gruppo/enabled): usato sia per il rendering che per l'export
        // "tabella visualizzata", cosi' i due sono sempre coerenti tra loro.
        clientiFiltrati() {
            if (!this.search) return this.clienti;
            const q = this.search.toLowerCase();
            return this.clienti.filter((c) => {
                const campi = [
                    c.companyCode, c.ragioneSociale, c.gruppo, c.certificazione,
                    this.formattaDataVisibile(c.dataAuditFSCS), this.formattaDataVisibile(c.dataAuditFSCG),
                    this.formattaDataVisibile(c.dataAuditFPC), this.formattaDataVisibile(c.dataAuditISO),
                    this.formattaDataVisibile(c.dataAuditPEFC), this.formattaDataVisibile(c.dataAuditPEFCG),
                    c.enabled ? "Abilitato" : "Disabilitato",
                ];
                return campi.some((v) => v && String(v).toLowerCase().includes(q));
            });
        },

        anniEsportaLoghi() {
            const annoCorrente = new Date().getFullYear();
            const anni = [];
            for (let a = annoCorrente; a >= 2025; a--) anni.push(a);
            return anni;
        },
    },
};
</script>